<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card class="html bg-transparent my-8-px" flat>
        <div v-if="data.content">
          <div class="content" v-html="data.content"></div>
        </div>
        <div
          v-else-if="modifyMode.show && editedAuth"
          class="grey--text text-center py-10-px grey lighten-2"
        >
          #{{ data.ctxId }} 無英文版 一般內文
        </div>
        <v-fade-transition
          v-if="modifyMode.show && editedAuth && createMode === -1"
        >
          <v-overlay v-if="hover" absolute :color="hoverColor">
            <v-btn plain @click.stop="setCreateMode({ obj: data, mode: 0 })">
              <v-icon left class="fz-16-px">mdi-square-edit-outline</v-icon>
              EDIT
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Html',

  props: ['data', 'hoverColor', 'modifyMode', 'editedAuth'],

  data() {
    return {}
  },

  computed: {
    ...mapState('document', ['createMode'])
  },

  methods: {
    ...mapActions('document', ['setCreateMode'])
  }
}
</script>

<style lang="scss" scoped>
.ctxIdTag {
  position: absolute;
  right: calc(100% + 2px);
}
.content {
  word-wrap: break-word;
}
</style>
